import store from '@/store';
import router from '@/router';
import { Feature } from '@/models';
import PermissionService, { PermissionType } from './PermissionService';

function routeTo(path: string) {
  if (path && router.currentRoute.path !== path) {
    router.push(path);
  }
}

async function loadMenus() {
  const menuList = [];
  let featureFlags = store.state.featureFlag && store.state.featureFlag.featureFlags;

  if (!featureFlags || featureFlags.length === 0) {
    await store.dispatch('loadFeatureFlags');

    featureFlags = store.state.featureFlag && store.state.featureFlag.featureFlags;
  }

  for (const featureFlag of featureFlags) {
    switch (featureFlag.feature) {
      // case Feature.Dashboard:
      //   menuList.push(
      //     {
      //       position: 1,
      //       title: 'Dashboard',
      //       icon: 'mdiViewDashboard',
      //       feature: Feature.Dashboard,
      //       routePrefix: 'dashboard',
      //       onclick: () => {
      //         routeTo('/dashboard');
      //       },
      //       roles: [PermissionType.ADMIN],
      //     },
      //   );
      //   break;
      case Feature.Chat:
        menuList.push(
          {
            position: 2,
            title: 'Conversas',
            icon: 'mdiMessage',
            feature: Feature.Chat,
            routePrefix: 'chat',
            onclick: () => {
              routeTo('/chat');
            },
            roles: [],
          },
        );
        break;
      case Feature.Campaign:
        menuList.push(
          {
            position: 3,
            title: 'Campanha',
            icon: 'mdiBullhorn',
            feature: Feature.Campaign,
            routePrefix: 'campaign',
            onclick: () => {
              routeTo('/campaign');
            },
          },
        );
        break;
      // case Feature.BotMaker:
      //   menuList.push(
      //     {
      //       position: 4,
      //       title: 'Bots',
      //       icon: 'mdiRobot',
      //       feature: Feature.BotMaker,
      //       routePrefix: 'bots',
      //       onclick: () => {
      //         routeTo('/bots');
      //       },
      //       roles: [PermissionType.ADMIN],
      //     },
      //   );
      //   break;
    }
  }

  menuList.push(
    {
      position: 4,
      title: 'Bots',
      icon: 'mdiRobot',
      feature: Feature.BotMaker,
      routePrefix: 'bots',
      onclick: () => {
        routeTo('/bots');
      },
      roles: [PermissionType.ADMIN],
    },
  );

  return menuList.filter((menu: any) => (
    !menu.roles || PermissionService.checkPermissions(menu.roles)
  )).sort(sortPosition);
}

function sortPosition(a: any, b: any) {
  if (a.position < b.position) {
    return -1;
  }
  if (a.position > b.position) {
    return 1;
  }
  return 0;
}

const MenuService = {
  loadMenus,
};

export default MenuService;
